import { createClient } from '@supabase/supabase-js';

// Public anon credentials — safe for client bundle; used as fallback when
// REACT_APP_* env vars are not set at build time (e.g. Vercel misconfiguration).
const DEFAULT_SUPABASE_URL = 'https://axvjdnlumfbszdwlcata.supabase.co';
const DEFAULT_SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF4dmpkbmx1bWZic3pkd2xjYXRhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMwNDcwNTQsImV4cCI6MjA3ODYyMzA1NH0.nBqPR9RtM5ZJc31CB6upWZj1rvp9GEkGi_IBu7WDHoU';

export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || DEFAULT_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || DEFAULT_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  console.warn(
    'Using built-in Supabase defaults. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in Vercel for explicit config.'
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export default supabase;
